export default __webpack_public_path__ + "static/media/article_body.a8f5ded9.png";